import * as React from "react";
import { Button, KIND as BUTTON_KIND } from "baseui/button";
import { Icon } from "kanopi-components/icons/Icon";
import { SidePadder } from "kanopi-components/SpaceWrapper/SidePadder";
import { StatefulPopover } from "baseui/popover";
import { useStyletron } from "kanopi-components/theme/useStyletron";
import { VerticalSpacer } from "kanopi-components/SpaceWrapper/VerticalSpacer";

export const MenuActions: React.FC<{ actions: React.ReactNode[] }> = ({ actions }) => {
  const [, theme] = useStyletron();
  return (
    <StatefulPopover
      content={() => (
        <SidePadder
          paddingTop={theme.sizing.scale700}
          paddingBottom={theme.sizing.scale700}
        >
          <VerticalSpacer gridRowGap={0}>{actions}</VerticalSpacer>
        </SidePadder>
      )}
      returnFocus
      autoFocus
    >
      <Button
        kind={BUTTON_KIND.tertiary}
        overrides={{
          BaseButton: {
            style: {
              paddingTop: theme.sizing.scale200,
              paddingBottom: theme.sizing.scale200,
            },
          },
        }}
      >
        <Icon
          icon="dots-vertical"
          size={theme.sizing.scale600}
          color={theme.colors.contentTertiary}
        />
      </Button>
    </StatefulPopover>
  );
};
